import { render, staticRenderFns } from "./CtcProvenanceBadge.vue?vue&type=template&id=4602a402&"
import script from "./CtcProvenanceBadge.vue?vue&type=script&lang=js&"
export * from "./CtcProvenanceBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports